export const habaAltText = {
  altText: {
    habaLogo: 'Wehrfritz',
    slowRequestWatchClock:
      'Symbol für Anfrage – steht für Anforderung oder Bestellvorgang bei HABA Play',
    paymentLogo: {
      advancePayment: 'Vorkasse-Symbol – Zahlung per Banküberweisung bei HABA Play',
      ct_creditcard_hop: 'Mastercard- und Visa-Logos – Zahlung mit Kreditkarte bei HABA Play',
      ct_paypal: 'PayPal-Logo – sichere Online-Zahlung bei HABA Play',
      paypalInstallment: 'PayPal-Ratenzahlung-Logo – flexible Zahlung in Raten bei HABA Play',
      debit: 'Lastschrift-Symbol – Zahlung per Bankeinzug bei HABA Play',
      invoice: 'Rechnung-Symbol – Kauf auf Rechnung bei HABA Play',
      fallback: 'Zahlungssymbol – steht für sichere Bezahlung bei HABA Play',
    },
  },
};
